import React from 'react';

import { flagStyles } from '../settings';

const SvgKY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2928px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKY;
